<template>
  <footer class="footer-area bg-white text-center rounded-top-7 py-3">
    <p class="fs-14 mb-0">
      © <span class="text-primary-div fw-semibold">RayaCheck.id</span> — All Rights Reserved
    </p>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
